import PropTypes from "prop-types"
import React from "react"
import { Box, Card, Typography } from "@material-ui/core"
import moment from "moment"
import CheckIcon from "@material-ui/icons/Check"
import MailOutlineIcon from "@material-ui/icons/MailOutline"

import useStyles from "./styles"

const SendLog = ({ data = {} }) => {
  const classes = useStyles()

  let estimateReceived = data &&
    Boolean(data.estimate_sent || data.estimate_sent_date) && {
      status: "Sent",
      timestamp: moment(
        data.estimate_sent_date_time || data.estimate_sent_date
      ).format("M/D/YY[ @ ]h:mm A"),
    }
  let estimateAccepted = data &&
    Boolean(data.estimate_accepted || data.estimate_accepted_date) && {
      status: "Accepted",
      timestamp: moment(
        data.estimate_accepted_date_time || data.estimate_accepted_date
      ).format("M/D/YY[ @ ]h:mm A"),
    }
  let invoiceReceived = data &&
    Boolean(data.invoice_sent || data.invoice_sent_date) && {
      status: "Sent",
      timestamp: moment(
        data.invoice_sent_date_time || data.invoice_sent_date
      ).format("M/D/YY[ @ ]h:mm A"),
    }
  let invoiceAccepted = data &&
    Boolean(data.invoice_accepted || data.invoice_accepted_date) && {
      status: "Accepted",
      timestamp: moment(
        data.invoice_accepted_date_time || data.invoice_accepted_date
      ).format("M/D/YY[ @ ]h:mm A"),
    }

  let noStatus =
    !invoiceAccepted &&
    !invoiceReceived &&
    !estimateAccepted &&
    !estimateReceived

  //only show a received row with the data.estimate_sent, only show accepted row if data.estimate_accepted
  if (noStatus) {
    return null
  }
  return (
    <Box>
      <Box display="flex" justifyContent="flex-start">
        <Typography className={classes.text}>Send Log</Typography>
      </Box>
      {estimateReceived &&
        estimateReceived.timestamp && (
          <Card classes={{ root: classes.card }}>
            <Box display="flex" justifyContent="space-between">
              <Typography className={classes.text}>
                Estimate {estimateReceived.status} on{" "}
                {estimateReceived.timestamp}
              </Typography>
              {/* <Grid item xs={3}>
                  <Typography className={classes.text}>
                    ${x.total.toLocaleString()}
                  </Typography>
                </Grid> */}
              <Box className={classes.acceptedDot}>
                <MailOutlineIcon className={classes.whiteIcon} />
              </Box>
            </Box>
          </Card>
        )}
      {estimateAccepted &&
        estimateAccepted.timestamp && (
          <Card classes={{ root: classes.card }}>
            <Box display="flex" justifyContent="space-between">
              <Typography className={classes.text}>
                Estimate {estimateAccepted.status} {estimateAccepted.timestamp}
              </Typography>
              {/* <Grid item xs={3}>
                  <Typography className={classes.text}>
                    ${x.total.toLocaleString()}
                  </Typography>
                </Grid> */}
              <Box className={classes.acceptedDot}>
                <CheckIcon className={classes.whiteIcon} />
              </Box>
            </Box>
          </Card>
        )}
      {invoiceReceived &&
        invoiceReceived.timestamp && (
          <Card classes={{ root: classes.card }}>
            <Box display="flex" justifyContent="space-between">
              <Typography className={classes.text}>
                Invoice {invoiceReceived.status} on {invoiceReceived.timestamp}
              </Typography>
              {/* <Grid item xs={3}>
                  <Typography className={classes.text}>
                    ${x.total.toLocaleString()}
                  </Typography>
                </Grid> */}
              <Box className={classes.acceptedDot}>
                <MailOutlineIcon className={classes.whiteIcon} />
              </Box>
            </Box>
          </Card>
        )}
      {invoiceAccepted &&
        invoiceAccepted.timestamp && (
          <Card classes={{ root: classes.card }}>
            <Box display="flex" justifyContent="space-between">
              <Typography className={classes.text}>
                Invoice {invoiceAccepted.status} {invoiceAccepted.timestamp}
              </Typography>
              {/* <Grid item xs={3}>
                  <Typography className={classes.text}>
                    ${x.total.toLocaleString()}
                  </Typography>
                </Grid> */}
              <Box className={classes.acceptedDot}>
                <CheckIcon className={classes.whiteIcon} />
              </Box>
            </Box>
          </Card>
        )}
    </Box>
  )
}

SendLog.propTypes = {
  data: PropTypes.object,
}

export default SendLog
